/**
 * 卡片工具函数
 * 用于信用卡显示、格式化等功能
 */

// 导入本地图标
// import visaIcon from '../images/payment/visa.svg';
// import mastercardIcon from '../images/payment/mastercard.svg';
// import amexIcon from '../images/payment/amex.svg';
// import discoverIcon from '../images/payment/discover.svg';
// import genericCardIcon from '../images/payment/generic-card.svg';


// CDN 备选图标 URL
// const cdnIcons = {
//   visa: 'https://q.stripe.com/payment-method-logos/visa_c89dad10cbbe5c0fde32e9c2c7559601010748fdbe827607284ce5851772fce1.svg',
//   mastercard: 'https://q.stripe.com/payment-method-logos/mastercard_6fe99a1fe0bdeb2402c852a35fe4afcf954c04ed98d74b916a8b18b48e438ce0.svg',
//   amex: 'https://q.stripe.com/payment-method-logos/amex_e3b8df41a6b73d24d5876f48e10f57ae0b5a5f0b1c03d34303709e5c9a73d941.svg',
//   discover: 'https://q.stripe.com/payment-method-logos/discover_0e6cbcb52e53f1fa5f90a15ca72567a369e256ccfcee8d59afa7f0dc4d0c6b1a.svg',
//   diners: 'https://q.stripe.com/payment-method-logos/diners_b966b1e76366dcdce1a701aaa6f698cf1f0a7e7d2ff43f3b92d76ab4cba6d996.svg',
//   jcb: 'https://q.stripe.com/payment-method-logos/jcb_f0fa4f9c0554e6d9c8ed605af9affb96ed6ac76c1f82ebaf3e5e826bcbfb2778.svg',
//   unionpay: 'https://js.stripe.com/v3/fingerprinted/img/unionpay-8a10aefc7295216c338ba4e1224627a1.svg',
//   generic: 'https://q.stripe.com/payment-method-logos/unknown_41da50ade40ec3ca1d54775d7a4d23374c80f62b0fbe99af150de719c4b95ed0.svg',
// };

// 对应本地导入
// const localIcons = {
//   visa: visaIcon,
//   mastercard: mastercardIcon,
//   amex: amexIcon,
//   discover: discoverIcon,
//   generic: genericCardIcon,
// };

// 支持的品牌别名映射到标准键
// const aliasMap = {
//   'american express': 'amex',
//   amex: 'amex',
//   visa: 'visa',
//   mastercard: 'mastercard',
//   'diners club': 'diners',
//   diners: 'diners',
//   jcb: 'jcb',
//   unionpay: 'unionpay',
// };

/**
 * 根据卡品牌获取图标 URL
 * @param {string} brand - 卡品牌（如 'visa', 'American Express'）
 * @returns {string} - 本地或 CDN 图标 URL
 */
// export function getCardBrandIcon(brand) {
//   if (typeof brand !== 'string') {
//     // 非字符串统一回退 generic
//     return localIcons.generic || cdnIcons.generic;
//   }

//   // 归一化品牌名
//   const key = aliasMap[brand.trim().toLowerCase()] || 'generic';

//   // 优先返回本地图标，否则回退到 CDN，再回退到 generic
//   return localIcons[key] || cdnIcons[key] || (localIcons.generic || cdnIcons.generic);
// }

// 本地仅保留通用图标导入
// import genericCardIcon from '../images/payment/generic-card.svg';

// 稳定 CDN 源：Flat 风格 SVG（也可改用 flat-rounded、logo 等目录）
// Raw GitHub
const rawBase = 'https://raw.githubusercontent.com/aaronfagan/svg-credit-card-payment-icons/master/flat';
// jsDelivr CDN（推荐生产环境使用）
let jsDelivrBase = 'https://cdn.jsdelivr.net/gh/aaronfagan/svg-credit-card-payment-icons@master/flat';
jsDelivrBase = rawBase
// 各品牌图标映射
const cdnIcons = {
  visa:   `${jsDelivrBase}/visa.svg`,          // Visa 图标 :contentReference[oaicite:0]{index=0}
  mastercard: `${jsDelivrBase}/mastercard.svg`,// Mastercard 图标 :contentReference[oaicite:1]{index=1}
  unionpay: `${jsDelivrBase}/unionpay.svg`,    // UnionPay 图标 :contentReference[oaicite:6]{index=6}
  discover: `${jsDelivrBase}/discover.svg`,    // Discover 图标 :contentReference[oaicite:3]{index=3}
  diners: `${jsDelivrBase}/diners.svg`,        // Diners Club 图标 :contentReference[oaicite:4]{index=4}
  jcb:    `${jsDelivrBase}/jcb.svg`,           // JCB 图标 :contentReference[oaicite:5]{index=5}
  generic: `${jsDelivrBase}/generic.svg`,      // 通用回退图标 :contentReference[oaicite:7]{index=7}
  amex:   `${jsDelivrBase}/american-express.svg`,// AmEx 图标 :contentReference[oaicite:2]{index=2}
};
// 当 cardBrand 为空时，默认展示的前三个品牌（可自由增删）
const DEFAULT_BRANDS = ['unionpay','visa', 'mastercard'];

// 支持的品牌别名映射
const aliasMap = {
  visa:        'visa',
  mastercard:  'mastercard',
  'master card':'mastercard',
  amex:        'amex',
  'american express': 'amex',
  discover:    'discover',
  diners:      'diners',
  'diners club':'diners',
  jcb:         'jcb',
  unionpay:    'unionpay',
};

/**
 * 获取卡品牌图标 URL
 * @param {string} brand - 卡品牌（如 'Visa', 'american express'）
 * @returns {string} 本地或 CDN 图标 URL
 */
export function getCardBrandIcon(brand) {
  // 归一化并映射别名，默认 generic :contentReference[oaicite:8]{index=8}
  const key = String(brand || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/, ' ');
  const mapped = aliasMap[key] || 'generic';
  // console.log('映射品牌:', key, '到:', mapped); // 调试输出
  // 尝试本地通用图标，否则使用 CDN 映射，再回退到 generic :contentReference[oaicite:9]{index=9}
  return cdnIcons[mapped] || cdnIcons.generic || cdnIcons['generic'];
};

export function CardIconOverlay({ cardBrand }) {
  // 如果有具体品牌，就只显示该品牌图标；否则显示前三个默认品牌图标
  const brandsToShow = cardBrand
    ? [cardBrand]
    : DEFAULT_BRANDS;

  return (
    <div
      className="card-icon"
      style={{
        position: 'absolute',
        zIndex: 2,
        left: 0,
        display: 'flex',
        gap: 4,           // 图标之间留一点间距
      }}
    >
      {brandsToShow.map((b, idx) => (
        <img
          key={idx}
          src={getCardBrandIcon(b) }
          alt={b}
          style={{
            width: 24,
            height: 24,
            objectFit: 'contain',
          }}
        />
      ))}
    </div>
  );
}

/**
 * 格式化过期日期
 * @param {string|number} month - 月份
 * @param {string|number} year - 年份
 * @returns {string} - 格式化后的过期日期，如 "MM/YY"
 */
export const formatExpiryDate = (month, year) => {
  if (!month || !year) return '••/••';
  
  // 确保月份是两位数
  const formattedMonth = String(month).padStart(2, '0');
  
  // 如果年份是四位数，只取后两位
  const formattedYear = String(year).length === 4 
    ? String(year).slice(2) 
    : String(year).padStart(2, '0');
  
  return `${formattedMonth}/${formattedYear}`;
};

/**
 * 生成信用卡显示格式的卡号
 * @param {string} last4 - 卡号后四位
 * @returns {string} - 格式化后的卡号展示
 */
export const formatCardNumber = (last4) => {
  if (!last4) return '•••• •••• •••• ••••';
  return `•••• •••• •••• ${last4}`;
};

/**
 * 获取详细的支付错误信息
 * @param {Object} error - Stripe错误对象
 * @returns {string} - 用户友好的错误信息
 */
export const getDetailedErrorMessage = (error) => {
  // 直接返回后端提供的错误消息，不再进行错误码映射
  console.log('处理支付错误:', error); // 记录完整错误对象，以便调试
  
  // 优先返回后端提供的消息
  if (error.message) {
    return error.message;
  }
  
  // 检查嵌套的错误对象中的消息
  if (error.error && error.error.message) {
    return error.error.message;
  }
  
  // 最后的备选方案
  return '支付处理过程中出现错误，请重试';
  
  /* 注释掉原有的错误码映射逻辑，完全依赖后端提供的本地化消息
  // 确保详细的Stripe错误代码消息映射
  const errorMessages = {
    'card_declined': '您的卡片被拒绝，请使用其他卡片',
    'insufficient_funds': '您的卡余额不足，请使用其他支付方式',
    'card_velocity_exceeded': '您的卡片短时间内交易次数过多，请稍后再试',
    'expired_card': '您的卡片已过期，请更换卡片',
    'incorrect_cvc': 'CVC安全码错误，请检查后重试',
    'processing_error': '处理您的支付时出错，请重试',
    'invalid_card_number': '卡号无效，请检查后重试',
    'invalid_expiry_date': '过期日期无效，请检查后重试',
    'invalid_cvc': 'CVC码无效，请检查后重试',
    'rate_limit': '请求过于频繁，请稍后再试',
    'authentication_required': '需要身份验证，请完成3D Secure认证',
    'approve_with_id': '此交易需要授权，请联系您的银行',
    'call_issuer': '请联系您的银行授权此交易',
    'do_not_honor': '银行拒绝了此交易，请联系您的银行或尝试其他支付方式',
    'do_not_try_again': '此卡交易被永久拒绝，请使用其他卡片',
    'fraudulent': '此交易被标记为可能欺诈，请联系您的银行',
    'generic_decline': '您的卡被拒绝，请检查卡信息或尝试其他卡片',
    'invalid_account': '卡号对应的账户无效，请联系您的银行',
    'lost_card': '此卡已被报失，请联系您的银行',
    'stolen_card': '此卡已被报告被盗，请联系您的银行',
    'pickup_card': '您的银行请求扣留此卡，请使用其他支付方式'
  };
  
  // 定义decline_code到错误消息的映射
  const declineCodeMessages = {
    'insufficient_funds': '您的卡余额不足，请使用其他支付方式',
    'lost_card': '此卡已被报失，请联系您的银行',
    'stolen_card': '此卡已被报告被盗，请联系您的银行',
    'expired_card': '您的卡片已过期，请更换卡片',
    'incorrect_cvc': 'CVC安全码错误，请检查后重试',
    'processing_error': '处理您的支付时出错，请重试',
    'incorrect_address': '地址验证失败，请检查您的账单地址',
    'incorrect_zip': '邮编验证失败，请检查您的账单地址',
    'authentication_required': '需要身份验证，请完成3D Secure认证',
    'do_not_honor': '银行拒绝了此交易，请联系您的银行或尝试其他支付方式',
    'generic_decline': '您的卡被拒绝，请检查卡信息或尝试其他卡片',
  };
  
  console.log('处理支付错误:', error); // 记录完整错误对象，以便调试
  
  // 1. 首先检查decline_code (Stripe卡被拒绝的具体原因)
  if (error.decline_code && declineCodeMessages[error.decline_code]) {
    console.log(`找到decline_code ${error.decline_code}，返回相应消息`);
    return declineCodeMessages[error.decline_code];
  }
  
  // 2. 检查错误对象嵌套结构中的decline_code
  if (error.error && error.error.decline_code && declineCodeMessages[error.error.decline_code]) {
    console.log(`找到嵌套decline_code ${error.error.decline_code}，返回相应消息`);
    return declineCodeMessages[error.error.decline_code];
  }
  
  // 3. 然后检查是否有明确的错误代码
  if (error.code && errorMessages[error.code]) {
    console.log(`找到错误代码 ${error.code}，返回相应消息`);
    return errorMessages[error.code];
  }
  
  // 4. 检查Stripe错误对象嵌套结构中的code
  if (error.error && error.error.code && errorMessages[error.error.code]) {
    console.log(`找到嵌套错误代码 ${error.error.code}，返回相应消息`);
    return errorMessages[error.error.code];
  }
  
  // 5. 检查是否是验证错误
  if (error.type === 'validation_error' || (error.error && error.error.type === 'validation_error')) {
    return '请检查您的卡片信息是否正确';
  }
  
  // 6. 返回任何可能的错误消息，或者默认消息
  return error.message || (error.error && error.error.message) || '支付处理过程中出现错误，请重试';
  */
};

/**
 * 获取卡品牌显示名称
 * @param {string} brand - 卡品牌代码
 * @returns {string} - 显示名称
 */
export const getCardBrandDisplayName = (brand) => {
  const brandLower = brand ? brand.toLowerCase() : '';
  
  switch (brandLower) {
    case 'visa':
      return 'Visa';
    case 'mastercard':
      return 'Mastercard';
    case 'amex':
      return 'American Express';
    case 'discover':
      return 'Discover';
    case 'diners':
      return 'Diners Club';
    case 'jcb':
      return 'JCB';
    case 'unionpay':
      return 'UnionPay';
    default:
      return brand ? brand.charAt(0).toUpperCase() + brand.slice(1) : 'Card';
  }
};